import React from 'react'
import styles from './Navbar.module.css'
import { Link } from 'gatsby'
import { AnchorLink } from "gatsby-plugin-anchor-links";
import DrawerToggleButton from './DrawerToggleButton'

export default function Navbar({navScroll, toggleDrawer}) {
    const ListLink = props => (
        <li className={styles.list}>
          <Link to={props.to} activeClassName={styles.active}>{props.children}</Link>
        </li>
      )
    const NavList = () => (
        <ul>
            <ListLink to="/about">Миний  тухай</ListLink>
            <li className={styles.list}>
                <div className={styles.subnav}>
                    <button className={styles.dropbtn}>Тусгай 
                    
                    зөвшөөрөл</button>            
                    <div className={styles.subnav_content}>
                            <AnchorLink to="/license/#license-1" activeClassName={styles.subnav_active}>Аудит</AnchorLink>
                            <AnchorLink to="/license/#license-2" activeClassName={styles.subnav_active}>Сургалт</AnchorLink>
                            <AnchorLink to="/license/#license-3" activeClassName={styles.subnav_active}>ISO 50001 стандарт</AnchorLink>
                            <AnchorLink to="/license/#license-4" activeClassName={styles.subnav_active}>ЭХББ-ын төсөв</AnchorLink>
                    </div>
                </div>
                </li>
            <ListLink to="/legal">Хууль,  журам</ListLink>

                <li className={styles.list}>
                <div className={styles.subnav}>
                    <button className={styles.dropbtn}>Үйлчилгээ</button>            
                    <div className={styles.subnav_content}>
                            <Link to="/services/energyaudit" activeClassName={styles.subnav_active}>Эрчим хүчний аудит</Link>
                            <Link to="/services/dah" activeClassName={styles.subnav_active}>Дулаан алдагдлын хэмжилт</Link>
                            <Link to="/services/training" activeClassName={styles.subnav_active} >Сургалт</Link>
                            <Link to="/services/iso50001" activeClassName={styles.subnav_active} >ISO 50001 стандартын зөвлөх үйлчилгээ</Link>
                            <Link to="/services/research" activeClassName={styles.subnav_active} >Судалгаа, шинжилгээ</Link>
                            <Link to="/" >Барилгын эрчим хүчний үнэлгээ</Link>
                    </div>
                </div>
                </li>
            <ListLink to="/works">Хэрэгжүүлсэн төслүүд</ListLink>
            <ListLink to="/photoalbum">Зургийн цомог</ListLink>
            <ListLink to="/advisory">Зөвлөмж</ListLink>
            <li className={styles.list}>
                <AnchorLink to="/#contact"> Холбоо  барих </AnchorLink>
            </li>
        </ul>
    )
    return (
        <>
        <div className={navScroll ? styles.bottom_container : styles.container}>
            <div className={styles.layout}>
                <header className={navScroll ? styles.header_down : styles.header}>
                            <AnchorLink to="/#top">
                            <div className={styles.logo}>
                                
                                    
                                    <h1>
                                        <p>эрчим</p>
                                        <p>хүчний</p>
                                        <p>аудит</p>  
                                    </h1>
                                    <img src="/logo_alt.svg" alt="logo"/>
                            
                            </div>
                            </AnchorLink>
                        <div className={styles.burger_menu} >
                            <DrawerToggleButton click={toggleDrawer}/>
                        </div>
                        <NavList/>
                </header>
                {/* <header className={styles.bottom_header}>
                        <NavList/>
                </header> */}
            </div>
           {/* <div className={navScroll ? styles.header_up : styles.header_down}>
                    <div className={styles.logo}>
                        <Link to="/">
                            <h1>эрчим хүчний аудит</h1>
                        </Link>
                    </div>
                    <div className={styles.burger_menu}>
                        <DrawerToggleButton/>
                    </div>
                    <NavList/>
            </div> */}
        </div>
            {/* <div className={styles.bottom_container}> 
                <div className={styles.layout}>
                    <header className={styles.bottom_header}>
                        <NavList/>
                    </header>
                </div>
            </div> */}
        </>
    )
}
